module.exports = new __parcel__URL__("machines_bp_piece_of_home_cosmetic_level_1.a2e3c4f4.png").toString();